import { lazy } from 'react';
import { retry } from '../../../config/utils';

const Business = lazy(() =>  retry(()=> import(/* webpackChunkName: "Business" */ "./Business")));

export default Business;